/* Sugar Knocker - shared behaviour, ported from the prototype's main.js.
   The prototype's localStorage cart and demo checkout are replaced by the
   Shopify Cart AJAX API and Shopify checkout. */
(function ($) {
  'use strict';

  // Images carry a responsive srcset (snippets/sk-srcset.liquid); a srcset wins over src, so when any script
  // swaps an image via .attr('src', ...) drop the srcset so the new image actually shows.
  $.attrHooks.src = {
    set: function (elem, value) {
      if (elem.nodeName === 'IMG' && elem.hasAttribute('srcset')) {
        elem.removeAttribute('srcset');
        elem.removeAttribute('sizes');
      }
    }
  };

  $(function () {
    $('body').addClass('sk-ready');
  });

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function fmt(n) {
    return '₹' + Number(n).toLocaleString('en-IN');
  }

  function fmtCents(cents) {
    return fmt(Math.round(cents) / 100);
  }

  var cartState = { items: [], item_count: 0, total_price: 0 };

  function applyCart(cart) {
    cartState = cart;
    $('#cart-count').text(String(cart.item_count));
    renderCartItems();
    return cart;
  }

  function fetchCart() {
    /* cache:false adds a timestamp so a cached cart.js can never leave the badge at a stale count */
    return $.ajax({ url: root + 'cart.js', dataType: 'json', cache: false }).then(applyCart);
  }

  /* GoKwik's side cart changes quantities / removes items through its own requests, which the header badge
     never saw (badge showed 2 while the cart had 1). Watch cart mutations from any script and re-sync. */
  var cartSyncTimer = null;
  function syncCartSoon() {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(function () { fetchCart(); }, 400);
  }
  var cartMutationRe = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (cartMutationRe.test(url)) p.then(syncCartSoon, function () {});
      return p;
    };
  }
  (function () {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && cartMutationRe.test(url)) {
        this.addEventListener('loadend', syncCartSoon);
      }
      return origOpen.apply(this, arguments);
    };
  })();
  /* Safety net: re-sync when the tab regains focus / returns from bfcache, */
  document.addEventListener('visibilitychange', function () { if (!document.hidden) syncCartSoon(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCartSoon(); });

  function changeLine(key, quantity) {
    return $.ajax({
      url: root + 'cart/change.js',
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ id: key, quantity: quantity })
    }).then(applyCart);
  }

  /* Buy Now feedback: the GoKwik SDK can take a few seconds on a slow phone, so the tapped button says
     what is happening instead of looking dead (and can't be tapped twice). */
  function setCheckoutBusy(btn, busy) {
    if (!btn || !btn.classList) return;
    if (busy) {
      if (btn.classList.contains('sk-btn-busy')) return;
      btn.setAttribute('data-sk-label', btn.innerHTML);
      btn.innerHTML = 'Opening secure checkout…';
      btn.classList.add('sk-btn-busy');
      btn.setAttribute('aria-busy', 'true');
    } else if (btn.classList.contains('sk-btn-busy')) {
      btn.innerHTML = btn.getAttribute('data-sk-label') || btn.innerHTML;
      btn.classList.remove('sk-btn-busy');
      btn.removeAttribute('aria-busy');
    }
  }

  /* Put the Buy Now label back as soon as the GoKwik cart is on screen (so it is already normal when the
     shopper closes it), and also if the tab is shown again or 4s pass without any overlay appearing. */
  function releaseWhenCheckoutShows(btn) {
    var done = false, obs = null;
    function release() {
      if (done) return;
      done = true;
      if (obs) obs.disconnect();
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('pageshow', release);
      setCheckoutBusy(btn, false);
    }
    function onVis() { if (!document.hidden) release(); }
    function overlayUp() {
      var nodes = document.querySelectorAll('iframe[src*="gokwik"], iframe[id*="gokwik"], [id*="gokwik"][class*="modal"], [class*="gokwik"][class*="modal"], [id^="gokwik"][style*="fixed"]');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetWidth > 0 || nodes[i].offsetHeight > 0) return true;
      }
      return false;
    }
    if (window.MutationObserver) {
      obs = new MutationObserver(function () { if (overlayUp()) release(); });
      obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('pageshow', release);
    setTimeout(release, 4000);
  }

  /* item: { id: variantId, quantity? } - legacy prototype fields (name/num/img) are ignored.
     btn (optional): the tapped Buy Now button, shown as busy until checkout opens. */
  function addToCart(item, checkout, btn) {
    if (!item || !item.id) return $.Deferred().reject().promise();
    if (checkout) {
      // GoKwik loads lazily (snippets/gokwik.liquid): start fetching the SDK now, in parallel with the cart add
      if (!window.gokwikSdk && window.skLoadGokwik) window.skLoadGokwik();
      setCheckoutBusy(btn, true);
    }
    return $.ajax({
      url: root + 'cart/add.js',
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ items: [{ id: Number(item.id), quantity: item.quantity || 1 }] })
    }).then(function () {
      if (checkout) {
        // window.location.href = root + 'checkout';
        var openCheckout = function () {
          window.gokwikSdk.initCheckout(merchantInfo);
          releaseWhenCheckoutShows(btn);
        };
        if (window.gokwikSdk) { openCheckout(); return; }
        var waited = 0;
        var timer = setInterval(function () {
          waited += 100;
          if (window.gokwikSdk) { clearInterval(timer); openCheckout(); }
          else if (waited >= 15000) { clearInterval(timer); window.location.href = root + 'checkout'; }
        }, 100);
        return;
      }
      return fetchCart().then(openCart);
    }, function () {
      setCheckoutBusy(btn, false);
    });
  }

  function renderCartItems() {
    var cart = cartState;
    var $wrap = $('#cart-items');
    if (!$wrap.length) return;
    $wrap.empty();
    if (!cart.items.length) {
      $('<p class="sk-cart-drawer__body-empty">Your cart is empty.</p>').appendTo($wrap);
    } else {
      cart.items.forEach(function (item) {
        var $row = $(
          '<div class="sk-cart-item">' +
            '<img loading="lazy" alt="" class="sk-cart-item__img">' +
            '<div class="sk-cart-item__body">' +
              '<div class="sk-cart-item__name"></div>' +
              '<div class="sk-cart-item__price"></div>' +
              '<div class="sk-cart-item__controls">' +
                '<div class="sk-cart-item__qty">' +
                  '<button type="button" data-action="dec" aria-label="Decrease quantity">−</button>' +
                  '<span></span>' +
                  '<button type="button" data-action="inc" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" data-action="remove" class="sk-cart-item__remove">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
        if (item.image) $row.find('.sk-cart-item__img').attr('src', item.image);
        $row.find('.sk-cart-item__name').text(item.product_title + (item.variant_title ? ' - ' + item.variant_title : ''));
        $row.find('.sk-cart-item__price').text(fmtCents(item.final_price));
        $row.find('.sk-cart-item__qty span').text(String(item.quantity));
        $row.find('[data-action="inc"]').on('click', function () { changeLine(item.key, item.quantity + 1); });
        $row.find('[data-action="dec"]').on('click', function () { changeLine(item.key, item.quantity - 1); });
        $row.find('[data-action="remove"]').on('click', function () { changeLine(item.key, 0); });
        $wrap.append($row);
      });
    }
    $('#cart-count-label').text(String(cart.item_count));
    $('#cart-subtotal').text(fmtCents(cart.total_price));
  }

  function openCartDrawer() {
    $('#cart-drawer-root').addClass('open');
    renderCartItems();
  }

  /* GoKwik loads lazily (snippets/gokwik.liquid). Open its side cart when it is available (waiting briefly for the
     lazy load), otherwise fall back to the theme's own cart drawer so the cart always opens. */
  function gokwikCartReady() {
    return typeof window.openGokwikSideCart === 'function' && window.kwikCartActive;
  }
  /* GoKwik's empty-cart "Explore products" button (no such text anywhere in the theme) is configured in the GoKwik dashboard and points at a single
     product variant. Send it to the shop page instead. */
  document.addEventListener('click', function (e) {
    var el = e.target;
    for (var n = 0; n < 4 && el && !/^\s*explore products\s*$/i.test(el.textContent || ''); n++) el = el.parentElement;
    if (!el || el === document.body || !/^\s*explore products\s*$/i.test(el.textContent || '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = root + 'collections/all';
  }, true);

  function openCart() {
    /* re-read the real cart first so the badge and GoKwik both start from the same state */
    fetchCart();
    function useGokwik() {
      try { if (typeof window.refreshSideCart === 'function') window.refreshSideCart(); } catch (e) {}
      window.openGokwikSideCart();
    }
    if (gokwikCartReady()) { useGokwik(); return; }
    if (!window.skLoadGokwik) { openCartDrawer(); return; }
    window.skLoadGokwik();
    var waited = 0;
    var timer = setInterval(function () {
      waited += 100;
      if (gokwikCartReady()) { clearInterval(timer); useGokwik(); }
      else if (waited >= 4000) { clearInterval(timer); openCartDrawer(); }
    }, 100);
  }
  function closeCartDrawer() {
    $('#cart-drawer-root').removeClass('open');
  }

  $(function () {
    fetchCart();

    var $menuToggle = $('#menu-toggle');
    var $mainNav = $('#main-nav');
    var $navBackdrop = $('#nav-backdrop');
    if ($menuToggle.length && $mainNav.length) {
      /* the open menu is pinned under the header and scrolls on its own; the page behind it is locked */
      var placeNav = function () {
        var hd = document.querySelector('.sk-header');
        document.documentElement.style.setProperty('--sk-nav-top', Math.max(0, Math.round(hd ? hd.getBoundingClientRect().bottom : 80)) + 'px');
      };
      var lockedY = 0;
      var setNav = function (open) {
        var root = document.documentElement;
        if (open === root.classList.contains('sk-nav-lock')) return;
        /* the body is fixed while the menu is open (see sk-responsive.css), so keep and restore the scroll position */
        if (open) {
          lockedY = window.pageYOffset || 0;
          document.body.style.top = -lockedY + 'px';
        }
        $mainNav.toggleClass('open', open);
        $navBackdrop.toggleClass('open', open);
        root.classList.toggle('sk-nav-lock', open);
        if (open) {
          placeNav(); setTimeout(placeNav, 60); setTimeout(placeNav, 350); // the header can settle after the page locks
        } else {
          document.body.style.top = '';
          window.scrollTo(0, lockedY);
        }
        $menuToggle.attr('aria-expanded', open ? 'true' : 'false');
      };
      $menuToggle.on('click', function () { setNav(!$mainNav.hasClass('open')); });
      $mainNav.on('click', 'a[href]:not(.sk-nav-dd__toggle)', function () { setNav(false); });
      $navBackdrop.on('click', function () { setNav(false); });
      $(document).on('keydown', function (e) { if (e.key === 'Escape') setNav(false); });
      $(window).on('resize', function () {
        if (window.innerWidth > 1240) { setNav(false); $('.sk-nav-dd.open, .sk-nav-dd__group.open').removeClass('open'); }
      });
    }

    /* ---------- Quinn doctor video sits right above the "Start Here" chat launcher (and above the product buy bar) ---------- */
    (function () {
      var GAP = 12;
      function place() {
        var q = document.getElementById('quinn-floating-widget'), b = document.getElementById('btn-trigger-chat');
        if (!q || !b) return;
        var cs = getComputedStyle(b);
        if (cs.display === 'none' || cs.visibility === 'hidden' || !b.offsetHeight) return;
        var lift = 0, tr = cs.translate; // the product page lifts the launcher with `translate` while the buy bar shows
        if (tr && tr !== 'none') { var p = tr.split(' '); lift = -(parseFloat(p[1]) || 0); }
        var bottom = Math.round((parseFloat(cs.bottom) || 20) + b.offsetHeight + lift + GAP);
        var right = Math.round(parseFloat(cs.right) || 16);
        q.style.setProperty('bottom', bottom + 'px', 'important');
        q.style.setProperty('right', right + 'px', 'important');
        q.style.setProperty('left', 'auto', 'important');
      }
      var timer;
      function soon() { clearTimeout(timer); place(); timer = setTimeout(place, 120); setTimeout(place, 420); }
      window.addEventListener('resize', soon);
      window.addEventListener('orientationchange', soon);
      if (window.MutationObserver) new MutationObserver(soon).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      /* the chat launcher and the video load late and on their own schedule, so check on a slow timer too */
      setInterval(place, 1000);
      soon();
    })();

    /* ---------- Product card image galleries (.sk-cg, snippets/card-gallery-slides.liquid) ----------
       Native horizontal scroll with snap does the swiping; this adds the position dots, fetches the next picture
       ahead of the swipe, lets a mouse drag the pictures, and returns to the first picture when a pack is picked
       (the pack choice swaps that picture). */
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-cg]'), function (cg) {
      var track = cg.querySelector('.sk-cg__track');
      var slides = track ? track.children : [];
      var n = slides.length;
      if (n < 2) return;
      var dots = document.createElement('span');
      dots.className = 'sk-cg__dots';
      dots.setAttribute('aria-hidden', 'true');
      for (var d = 0; d < n; d++) dots.appendChild(document.createElement('span')).className = 'sk-cg__dot';
      cg.appendChild(dots);
      function cur() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
      function warm(i) {
        [i, i + 1].forEach(function (j) {
          var img = slides[j] && slides[j].querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });
      }
      function mark() {
        var i = cur();
        warm(i);
        Array.prototype.forEach.call(dots.children, function (dot, k) { dot.classList.toggle('is-on', k === i); });
      }
      mark();
      track.addEventListener('scroll', mark, { passive: true });
      ['touchstart', 'pointerenter'].forEach(function (ev) { cg.addEventListener(ev, function () { warm(cur()); }, { passive: true, once: true }); });
      /* mouse: drag to move between pictures; a drag must not count as a click on the card / link */
      var drag = null, dragged = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { x: e.clientX, left: track.scrollLeft };
        dragged = 0;
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 5 && !track.classList.contains('is-dragging')) track.classList.add('is-dragging');
        if (track.classList.contains('is-dragging')) { track.scrollLeft = drag.left - dx; dragged = Date.now(); }
      });
      window.addEventListener('pointerup', function () {
        if (!drag) return;
        var from = Math.round(drag.left / (track.clientWidth || 1)), moved = track.scrollLeft - drag.left;
        drag = null;
        if (!track.classList.contains('is-dragging')) return;
        track.classList.remove('is-dragging');
        var to = Math.abs(moved) > track.clientWidth * 0.15 ? from + (moved > 0 ? 1 : -1) : from;
        to = Math.min(Math.max(to, 0), n - 1);
        track.scrollTo({ left: to * track.clientWidth, behavior: 'smooth' });
      });
      cg.addEventListener('click', function (e) {
        if (dragged && Date.now() - dragged < 300) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
    /* capture phase: the pack buttons' own handlers stop the click from bubbling */
    document.addEventListener('click', function (e) {
      var pack = e.target.closest && e.target.closest('.sk-pack-option, .product-card__pack-pill');
      var card = pack && pack.closest('.sk-product-slide, .product-card, .pd-companion-card');
      var track = card && card.querySelector('.sk-cg__track');
      if (track && track.scrollLeft) track.scrollTo({ left: 0, behavior: 'smooth' });
    }, true);

    /* ---------- Nav dropdowns: hover/focus opens on desktop (CSS); click toggles for touch ---------- */
    var isMobileNav = function () { return window.innerWidth <= 1240; };
    /* mobile: a menu item with a sub menu opens it instead of leaving the page (the sub menu has an "All ..." link) */
    $(document).on('click', '.sk-nav-dd__heading', function (e) {
      if (!isMobileNav()) return;
      e.stopPropagation();
      var $g = $(this).closest('.sk-nav-dd__group'), open = !$g.hasClass('open');
      $g.siblings('.sk-nav-dd__group').removeClass('open').children('.sk-nav-dd__heading').attr('aria-expanded', 'false');
      $g.toggleClass('open', open);
      $(this).attr('aria-expanded', open ? 'true' : 'false');
    });
    $(document).on('click', '.sk-nav-dd__toggle', function (e) {
      if (isMobileNav()) e.preventDefault();
      e.stopPropagation();
      var $dd = $(this).closest('.sk-nav-dd');
      var open = !$dd.hasClass('open');
      $('.sk-nav-dd.open').removeClass('open').find('.sk-nav-dd__toggle').attr('aria-expanded', 'false');
      if (open) { $dd.addClass('open'); $(this).attr('aria-expanded', 'true'); }
    });
    $(document).on('click', function (e) {
      if (isMobileNav() && $(e.target).closest('#main-nav').length) return; // taps inside the open mobile menu keep it as it is
      $('.sk-nav-dd.open').removeClass('open').find('.sk-nav-dd__toggle').attr('aria-expanded', 'false');
    });

    $('#cart-toggle').on('click', openCart);
    $('#cart-close').on('click', closeCartDrawer);
    $('#cart-backdrop').on('click', closeCartDrawer);
    $('#cart-checkout-btn').on('click', function () {
      if (!cartState.items.length) return;
      // Checkout through GoKwik (loaded on demand); native checkout if it does not come up
      if (window.gokwikSdk) { window.gokwikSdk.initCheckout(window.merchantInfo); return; }
      if (!window.skLoadGokwik) { window.location.href = root + 'checkout'; return; }
      window.skLoadGokwik();
      var coWaited = 0;
      var coTimer = setInterval(function () {
        coWaited += 100;
        if (window.gokwikSdk) { clearInterval(coTimer); window.gokwikSdk.initCheckout(window.merchantInfo); }
        else if (coWaited >= 15000) { clearInterval(coTimer); window.location.href = root + 'checkout'; }
      }, 100);
    });

    /* ---------- Generic add-to-cart buttons: data-sk-add="variantId" [data-sk-checkout] ---------- */
    $(document).on('click', '[data-sk-add]', function (e) {
      e.preventDefault();
      addToCart({ id: $(this).attr('data-sk-add') }, $(this).is('[data-sk-checkout]'), this);
    });

    /* ---------- Doctor endorsement videos (click-to-load) ---------- */
    $(document).on('click', '.sk-endorse__play', function () {
      var $btn = $(this);
      var $frame = $btn.closest('.sk-endorse__frame');
      if (!$frame.length) return;
      var $iframe = $('<iframe class="sk-endorse__iframe" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>');
      $iframe.attr('src', $btn.data('embed')).attr('title', $btn.data('title') || '');
      $frame.empty().append($iframe);
    });

    /* ---------- Muted looping video (facility video): embed once the frame scrolls into view ---------- */
    var loopFrames = document.querySelectorAll('[data-sk-loop]');
    if (loopFrames.length) {
      var startLoop = function (frame) {
        var id = frame.getAttribute('data-sk-loop');
        var btn = frame.querySelector('.sk-endorse__play');
        var iframe = document.createElement('iframe');
        iframe.className = 'sk-endorse__iframe';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('title', btn ? btn.getAttribute('data-title') || '' : '');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id +
          '?autoplay=1&mute=1&loop=1&playlist=' + id + '&controls=0&playsinline=1&rel=0&modestbranding=1';
        frame.innerHTML = '';
        frame.appendChild(iframe);
      };
      if ('IntersectionObserver' in window) {
        var loopObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            loopObs.unobserve(en.target);
            startLoop(en.target);
          });
        }, { rootMargin: '200px' });
        loopFrames.forEach(function (f) { loopObs.observe(f); });
      }
    }

    /* ---------- UGC shoppable video cards + modal (Home reels + Product page UGC) ---------- */
    var $ugcModal = $('#ugc-modal');
    if ($ugcModal.length) {
      var ugcSelected = { id: null };

      function ugcSyncPack($opt) {
        $('#ugc-modal-pack-selector .sk-pack-option').removeClass('selected');
        $opt.addClass('selected');
        var price = parseFloat($opt.data('price'));
        var mrp = parseFloat($opt.data('mrp'));
        ugcSelected = { id: $opt.data('variant-id') };
        $('#ugc-modal-price').text(fmt(price));
        $('#ugc-modal-mrp').text(fmt(mrp)).prop('hidden', !(mrp > price));
        $('#ugc-modal-pack-note').text($opt.data('note') || '');
      }
      $('#ugc-modal-pack-selector .sk-pack-option').on('click', function () { ugcSyncPack($(this)); });
      // Start on the pack marked selected in the markup (Buy 2 Get 1 FREE when the product has one)
      var $ugcFirstPack = $('#ugc-modal-pack-selector .sk-pack-option.selected').first();
      if (!$ugcFirstPack.length) $ugcFirstPack = $('#ugc-modal-pack-selector .sk-pack-option').first();
      if ($ugcFirstPack.length) ugcSyncPack($ugcFirstPack);

      /* Touch browsers block unmuted autoplay in an embed and show YouTube's own play button (a 2nd tap);
         start muted there so one tap plays. */
      var ugcCoarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

      function openUgcModal(videoId, title) {
        var src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0&playsinline=1&modestbranding=1&iv_load_policy=3' + (ugcCoarse ? '&mute=1' : '');
        var $iframe = $('<iframe allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>');
        $iframe.attr('src', src).attr('title', title || '');
        $('#ugc-modal-video-frame').empty().append($iframe);
        $ugcModal.prop('hidden', false).addClass('open');
        $('body').addClass('ugc-modal-open');
      }
      function closeUgcModal() {
        $ugcModal.removeClass('open').prop('hidden', true);
        $('body').removeClass('ugc-modal-open');
        $('#ugc-modal-video-frame').empty();
      }

      $(document).on('click', '.sk-ugc-card__btn', function () {
        var $card = $(this).closest('.sk-ugc-card');
        openUgcModal($card.data('video-id'), $card.data('title'));
      });
      $('#ugc-modal-close, #ugc-modal-backdrop').on('click', closeUgcModal);
      $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $ugcModal.hasClass('open')) closeUgcModal();
      });

      $('#ugc-modal-add').on('click', function () {
        addToCart(ugcSelected, false);
      });
      $('#ugc-modal-buy').on('click', function () {
        addToCart(ugcSelected, true, this);
      });
    }

    /* (Legacy) lazy muted autoplay preview for UGC cards - only the single most-visible card
       per reel track gets a live iframe, to avoid many concurrent YouTube embeds. */
    /* Disabled: the embedded YouTube iframe drew its own red play button on top of the theme's
       orange one. Cards now show the poster + a single theme play icon (video opens on tap). */
    if (false && 'IntersectionObserver' in window && $('.sk-ugc-card').length) {
      var ugcVisible = new Map();
      var ugcActiveByTrack = new Map();

      function ugcLoadPreview($card) {
        var $preview = $card.find('.sk-ugc-card__preview');
        if (!$preview.length || $preview.children().length) return;
        var vid = $card.data('video-id');
        var src = 'https://www.youtube-nocookie.com/embed/' + vid +
          '?autoplay=1&mute=1&loop=1&playlist=' + vid + '&controls=0&modestbranding=1&playsinline=1&rel=0';
        $preview.html('<iframe src="' + src + '" allow="autoplay; encrypted-media" tabindex="-1" aria-hidden="true"></iframe>');
      }
      function ugcUnloadPreview($card) {
        $card.find('.sk-ugc-card__preview').empty();
      }

      var ugcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var $card = $(entry.target);
          var trackEl = $card.closest('.hscroll, .pd-ugc__scroll')[0] || entry.target.parentElement;
          if (entry.isIntersecting) {
            ugcVisible.set(entry.target, { ratio: entry.intersectionRatio, track: trackEl });
          } else {
            ugcVisible.delete(entry.target);
            if (ugcActiveByTrack.get(trackEl) === entry.target) {
              ugcUnloadPreview($card);
              ugcActiveByTrack.delete(trackEl);
            }
          }
        });

        var byTrack = new Map();
        ugcVisible.forEach(function (info, el) {
          var list = byTrack.get(info.track) || [];
          list.push({ el: el, ratio: info.ratio });
          byTrack.set(info.track, list);
        });
        byTrack.forEach(function (list, trackEl) {
          var best = list.reduce(function (a, b) { return b.ratio > a.ratio ? b : a; });
          var current = ugcActiveByTrack.get(trackEl);
          if (current === best.el) return;
          if (current) ugcUnloadPreview($(current));
          ugcActiveByTrack.set(trackEl, best.el);
          ugcLoadPreview($(best.el));
        });
      }, { threshold: [0, 0.5, 0.75, 1] });
      $('.sk-ugc-card').each(function () { ugcObserver.observe(this); });
    }
  });

  /* ---------- Ingredient drawer: study links (shown as text, with a Copy button) ---------- */
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, text.length);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      document.body.removeChild(ta);
      if (ok) resolve(); else reject();
    });
  }

  function renderStudies(studies) {
    var $wrap = $('#ing-drawer-studies-wrap');
    var $list = $('#ing-drawer-studies');
    if (typeof studies === 'string') {
      try { studies = JSON.parse(studies); } catch (err) { studies = []; }
    }
    $list.empty();
    if (!studies || !studies.length) {
      $wrap.prop('hidden', true);
      return;
    }
    $.each(studies, function (_, s) {
      var $li = $('<li class="ing-studies__item">');
      $('<div class="ing-studies__title">').text(s.title).appendTo($li);
      if (s.type) $('<div class="ing-studies__type">').text(s.type).appendTo($li);
      var $row = $('<div class="ing-studies__row">').appendTo($li);
      $('<span class="ing-studies__url">').text(s.url).appendTo($row);
      $('<button type="button" class="ing-studies__copy js-copy-study">').attr('data-url', s.url).text('Copy link').appendTo($row);
      $list.append($li);
    });
    $wrap.prop('hidden', false);
  }

  $(document).on('click', '.js-copy-study', function () {
    var $btn = $(this);
    var url = $btn.attr('data-url');
    var $url = $btn.siblings('.ing-studies__url');
    var timer = $btn.data('resetTimer');
    if (timer) clearTimeout(timer);
    function flash(label, done) {
      $btn.text(label).toggleClass('is-copied', !!done);
      $btn.data('resetTimer', setTimeout(function () {
        $btn.text('Copy link').removeClass('is-copied');
      }, 2200));
    }
    copyText(url).then(function () {
      flash('Copied ✓', true);
    }, function () {
      var range = document.createRange();
      range.selectNodeContents($url[0]);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      flash('Press Ctrl+C', false);
    });
  });

  // Show the image of a pack option (data-img) in img. Plain src, no srcset: iOS Safari can keep painting the
  // previous picture after a scripted srcset change.
  function swapImg(img, opt) {
    if (!img || !opt || !opt.getAttribute('data-img')) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = opt.getAttribute('data-img');
  }

  window.SK = window.SK || {};
  window.SK.swapImg = swapImg;
  window.SK.renderStudies = renderStudies;
  window.SK.addToCart = addToCart;
  window.SK.fmt = fmt;
  window.SK.fmtCents = fmtCents;
})(jQuery);

/* Sticky header: the header group wrapper sticks, shifted up by the announcement bar's height so only the header stays. */
(function () {
  'use strict';
  function setAnnounceHeight() {
    var bar = document.querySelector('.sk-announce');
    document.documentElement.style.setProperty('--sk-announce-h', (bar ? bar.offsetHeight : 0) + 'px');
  }
  setAnnounceHeight();
  window.addEventListener('load', setAnnounceHeight);
  window.addEventListener('resize', setAnnounceHeight);
  document.addEventListener('shopify:section:load', setAnnounceHeight);
})();

/* App widgets that render icon-only buttons with no accessible name (Quinn's floating video close button). Name them
   so screen readers and AI agents can use them (Lighthouse "Agentic browsing": accessibility tree well-formed).
   Watches only while the page settles, then stops. */
(function () {
  var NAMES = [
    ['#quinn-floating-widget .quinn_floating_close-button', 'Close video'],
    ['#quinn-floating-widget button', 'Play video']
  ];
  var queued = false;
  function label() {
    queued = false;
    NAMES.forEach(function (n) {
      document.querySelectorAll(n[0]).forEach(function (b) {
        if (!b.getAttribute('aria-label') && !b.textContent.trim()) b.setAttribute('aria-label', n[1]);
      });
    });
  }
  if (!('MutationObserver' in window)) return;
  var mo = new MutationObserver(function () {
    if (!queued) { queued = true; requestAnimationFrame(label); }
  });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); label(); }, 60000);
})();
